import axios from 'axios'
import md5 from 'js-md5'
import JSSM4 from 'jssm4'
// import RSA from './wx_rsa.js'

import store from '../store/index.js'
const API = {
	dev: {
        // mainIP: 'http://192.168.9.51:8002/gateway/interfaces/mgm'
        mainIP: 'http://192.168.9.75:8002/gateway/interfaces/mgm'
        // mainIP: 'https://www.26dudt.com/bbg-mgm-minipro/mgm/interfaces/mgm'
    },
    sit: {
        mainIP: 'https://www.26dudt.com/bbg-mgm-minipro/mgm/interfaces/mgm',
    },
    uat: {
        mainIP: 'https://www.26dudt.com/bbg-mgm-minipro-uat/mgm/interfaces/mgm',
    },
    pro: {
        mainIP: 'https://mbank.bankofbbg.com/cismp/mgm/partner/interfaces/mgm'  // 生产
    }
}

const SM4_KEY = '8a6fb1b52bf249d9';
const SM4 = new JSSM4(SM4_KEY);
const PUBLIC_KEY = '-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKsloOY95Kble+mNjByRuj0Zak40AFL81jvCyL4CvUwt8yir6ykwCXf5SwnNC1PCaf2+iGQGPDgeegMXL3xgurECAwEAAQ==-----END PUBLIC KEY-----'

function getApi() {
    const location = window.location

    if (location.host == "mbank.bankofbbg.com") {
        return API['pro']
    } else if (location.host == "www.26dudt.com") {
        if (location.pathname == "/bbg-cdm-static-company/bbg-mgm/") {
            return API['sit']
        } else {
            return API['uat']
        }
    } else {
        return API['dev']
    }
}

function encryptSM4(val) {
    return SM4.encryptData_ECB(JSON.stringify(val));
}

// function encryptSM4Single(val) {
//     return SM4.encryptData_ECB(val);
// }

// function rsaEncrypt(val) {
//     let encrypt_rsa = new RSA.RSAKey();
//     encrypt_rsa = RSA.KEYUTIL.getKey(PUBLIC_KEY);
//     let encStr = encrypt_rsa.encrypt(val);
//     encStr = RSA.hex2b64(encStr);
//     return encStr;
// }

function isJSON(str) {
    if (typeof str == 'string') {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
}

function decryptSM4(val) {
    if (typeof val == 'object') {
        return val;
    }

    let data = SM4.decryptData_ECB(val);
    if (isJSON(data)) {
        return JSON.parse(data);
    } else {
        return val;
    }
}

// function decryptSM4Single(val) {
//     return SM4.decryptData_ECB(val);
// }
function setCookie(cname,cvalue,exdays){
    // offerActivityToken
    var d = new Date();
    d.setTime(d.getTime()+(exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  }
  function getCookie(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++)
    {
      var c = ca[i].trim();
      if (c.indexOf(name)==0) return c.substring(name.length,c.length);
    }
    return "";
  }
  function clearCookie(cname){
    gob.setCookie(cname, "", -1);
  }
function request(vueObj,option) {
    let params = {
        data: option.data || {},
        timestamp: new Date().getTime()
    }
    let sign = `${JSON.stringify(params)}MIIEvAIBADANBgkqhkiG9w0BAQEFAASC${params.timestamp}`
    let headers = {
        'sign': md5(sign),
        'Content-Type': 'application/json;charset=utf-8'
    }
    const token=getCookie('mgmActivityToken')
    if(token){
        headers['sessionId']= token
    }
    const url = option.newUrl ? option.newUrl : getApi().mainIP + option.url
    store.dispatch('setState', { name: 'LoadingOnOff', value: true })
    
    const service = axios.create({
        timeout: 3 * 1000
      })
    service.interceptors.request.use(config => {
         config.data =option.noEncrypt ? params : encryptSM4(params) 
         config.headers = headers
        return config
      }, error => {
        Promise.reject(error)
      })
      service.interceptors.response.use(response => {
        store.dispatch('setState', { name: 'LoadingOnOff', value: false })
        return response
      }, error => {
        store.dispatch('setState', { name: 'LoadingOnOff', value: false })
        if (error && error.response) {
          switch (error.response.status) {
            case 400:
              error.message = '错误请求'
              break;
            case 404:
              error.message = '请求错误'
              break;
            case 500:
              error.message = '服务器端出错'
              break;
            default:
              error.message = `连接错误${error.response.status}`
          }
        } else {
          if (JSON.stringify(error).includes('timeout')) {
            changeStore('AppTopTip', {onOff: true, text:'服务器响应超时，请刷新当前页'})
          }
          error.message = '连接服务器失败'
        }
        changeStore('AppTopTip', {onOff: true, text:error.message})
        return Promise.resolve(error.response)
      })

    return new Promise((resolve, reject) => {
        console.log(getApi().mainIP + option.url + '请求参数', params)
        if(option.method&&(option.method).toLowerCase()=='get'){
            service.get(
                url,
                {
                    params:option.noEncrypt ? params : encryptSM4(params),
                    headers:headers
                }
              ).then(function (response) {
                  store.dispatch('setState', { name: 'LoadingOnOff', value: false })
                  const resData = decryptSM4(response.data)
                  console.log(resData)
                    handleResStatus(vueObj,resData,()=>{
                      resolve(resData)
                    },()=>{
                      reject(resData)
                    })
                })
                .catch(function (error) {
                  store.dispatch('setState', { name: 'LoadingOnOff', value: false })
                  if(!option.noFailTip) changeStore('AppTopTip', {onOff: true, text:'请求失败'})
                  reject(error)
                })
                return
        }
        service.post(
            url,
            option.noEncrypt ? params : encryptSM4(params),
            {headers:headers}
          ).then(function (response) {
              store.dispatch('setState', { name: 'LoadingOnOff', value: false })
              const resData = decryptSM4(response.data)
              console.log(resData)
                handleResStatus(vueObj,resData,()=>{
                  resolve(resData)
                },()=>{
                  reject(resData)
                })
            })
            .catch(function (error) {
              store.dispatch('setState', { name: 'LoadingOnOff', value: false })
              if(!option.noFailTip) changeStore('AppTopTip', {onOff: true, text:'请求失败'})
              reject(error)
            })
    })
}
//改变store
function changeStore (name,param) {
    if(name==='AppTopTip'&&store.state.AppTopTip.onOff) return;
    store.dispatch('setState', { name:name, value: param})
  }
function handleResStatus(vueObj,resJson,callback,reject) {
    // 处理正常返回的状态
    var resultCode = resJson.code+'';
    var resultInfo = resJson.msg||resJson.desc;
    const successCode=['200'] 
    const errCode=['403','500'] 
     if (successCode.includes(resultCode)) {
      callback && callback()
    }else if (errCode.includes(resultCode)) {
      vueObj.$router.replace({
        name: 'errPage', query: {code: resultCode,tipStr:resultInfo}
      })
    }else{
      changeStore('AppTopTip', {onOff: true, text: resultInfo})
      if (reject) reject();
    }

  }
// function requestImg(option) {
//     let headers = {
//         'sessionId': wx.getStorageSync('sessionId'),
//         'content-type': 'application/json'
//     }
//     wx.showLoading({
//         mask: true,
//         title: '加载中',
//     })
//     return new Promise((resolve, reject) => {
//         wx.request({
//             url: getApi().mainIP + option.url,
//             timeout: 10000,
//             method: 'GET',
//             header: headers,
//             responseType: "arraybuffer",
//             success(response) {
//                 if (response.statusCode == 200) {
//                     var base64 = wx.arrayBufferToBase64(response.data);
//                     resolve("data:image/png;base64," + base64.replace(/[\r\n]/g, ''));
//                 } else {
//                     reject();
//                 }
//             },
//             fail(err) {
//                 reject(err);
//             },
//             complete(info) {
//                 wx.hideLoading();
//             }
//         })
//     })
// }


export {
    request,
    isJSON,
    changeStore,
    getCookie,
    setCookie,
    clearCookie,
    // requestImg,
    // encryptSM4Single,
    // decryptSM4,
    // decryptSM4Single,
    // rsaEncrypt
}


// WEBPACK FOOTER //
// ./src/utils/request.js